import { recursivelyCheckIfNullValues } from './location-stations-verify';

export const verifyStationsContent = (stationsState) => {
  const stations = { ...stationsState };

  delete stations.error;
  delete stations.loading;
  delete stations.selectedStation;

  return !recursivelyCheckIfNullValues(stations);
};

export const verifyStationContent = (station) => {
  return !recursivelyCheckIfNullValues(station);
};
